// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  orgId: __t.string().name("org_id"),
  repoOwner: __t.string().name("repo_owner"),
  repoName: __t.string().name("repo_name"),
  defaultLabels: __t.string().name("default_labels"),
  displayName: __t.string().name("display_name"),
  installVerified: __t.bool().name("install_verified"),
  createdBy: __t.identity().name("created_by"),
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.timestamp().name("updated_at"),
  installationId: __t.u64().name("installation_id"),
  availableToAllOrgs: __t.bool().name("available_to_all_orgs"),
  stamp: __t.option(__t.string()),
  sharedAcrossDeployments: __t.bool().name("shared_across_deployments"),
});
